import React, { useCallback, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import { useSteps } from '../../contexts/stepContext';
import api from '../../services/api';
import { Title } from '../../styles/global';
import { Content, GoBack } from '../BodyStep/styles';
import Button from '../Button';
import Dropzone from '../Dropzone';
import Loading from '../Loading';
import { Actions, UploadSection } from './styles';

interface IValidationResponse {
  message?: string;
  result?: string;
  service?: string;
}

const UploadDocument: React.FC = () => {
  const [loading, setLoading] = useState(false);

  const {
    handleChangeCurrentStep,
    handleReturnCurrentStep,
    imageDoc,
    handleSetImage,
    documentNum,
    documentType,
    name,
    setResult,
    setMessageError,
    setServiceError,
  } = useSteps();

  const handleDeleteImage = useCallback(() => {
    handleSetImage('');
  }, [handleSetImage]);

  const handleGoBack = useCallback(() => {
    handleReturnCurrentStep();
    handleSetImage('');
  }, []);

  const handleSubmit = async () => {
    setLoading(true);
    const { data } = (await api
      .post<IValidationResponse>('validationrequestdoc', {
        document: documentNum,
        selfie: imageDoc,
        name,
        document_type: documentType,
      })
      .then(response => response)) as { data: IValidationResponse };

    setLoading(false);
    if (data.result) setResult(data.result);
    if (data.message) setMessageError(data.message);
    if (data.service) setServiceError(data.service);
    handleChangeCurrentStep();
  };

  return (
    <>
      <Content>
        <GoBack onClick={handleGoBack}>
          <FaArrowLeft size={16} />
          voltar
        </GoBack>
        <Title>Upload do Documento</Title>
        <UploadSection>
          <Dropzone />
        </UploadSection>
        <Actions mobile={isMobile}>
          {imageDoc && (
            <>
              <Button title="LIMPAR" onClick={handleDeleteImage} />
              <Button
                title="PRÓXIMO"
                onClick={handleSubmit}
                icon={FaArrowRight}
              />
            </>
          )}
        </Actions>
      </Content>

      {loading && <Loading />}
    </>
  );
};

export default UploadDocument;
